module.exports = __webpack_public_path__ + "media/packs/images/flags/MX-efd37fc2cbcf252b40515cd88fd15aea.png";